import { render } from "./moments.vue?vue&type=template&id=572e6760"
const script = {}
script.render = render

export default script